export default __webpack_public_path__ + "static/media/muscle-icon.8690bea4.png";